import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface CustomerSender {
    sender_idx: number;
    default_sender: string;
    union_sender: string;
    union_option: boolean;
    status: boolean;
}

interface GetCustomerResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: CustomerSender[];
}

export const useGetCustomerSender = (customerId: number, page: number, searchtxt?: string): UseQueryResult<GetCustomerResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetCustomerResponse, Error>({
        queryKey: ["getCustomerSender", customerId, page, searchtxt],
        queryFn: async () => {
            const response = await axios.get(
                `${enum_api_uri.get_customer_sender.replace(":customer_idx", customerId.toString())}?page=${page}&limit=5&search=sender&searchtxt=${searchtxt}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                    current_page: page,
                };
            }
            return undefined;
        },
    });
};
